import { useMutation } from 'react-query';

/**
 * Services
 */
import getStrongPasswordRules from '@/src/services/auth/getStrongPasswordRules';

export function useStrongPasswordRules() {
  return useMutation(getStrongPasswordRules);
}
